// src/pages/Plano30Dias.jsx
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { NOMES_FATORES } from '../utils/gerarPlano30Dias';

export default function Plano30Dias() {
  const { state } = useLocation();
  const navigate = useNavigate();

  if (!state || !state.plano) {
    return (
      <div style={{ padding: 32 }}>
        <h2>Plano não encontrado</h2>
        <button onClick={() => navigate('/')}>Voltar</button>
      </div>
    );
  }

  const { resumo, semanas } = state.plano;

  return (
    <div style={{ maxWidth: 980, margin: '2rem auto', background: '#fff', borderRadius: 12, padding: 32, boxShadow: '0 2px 16px rgba(36,47,60,0.08)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <h2 style={{ fontWeight: 800, fontSize: 26 }}>Plano de 30 dias • ICV</h2>
        <div>
          <button
            style={{ marginRight: 8, padding: '10px 18px', borderRadius: 7, border: '1px solid #e3e7ee', background: '#f7f9fc', cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          >
            Voltar
          </button>
          <button
            style={{ padding: '10px 18px', borderRadius: 7, border: 'none', background: '#F36611', color: '#fff', fontWeight: 700, cursor: 'pointer' }}
            onClick={() => window.print()}
          >
            Imprimir
          </button>
        </div>
      </div>

      {/* Resumo de focos (menores PTs primeiro) */}
      <div style={{ background: '#F8FAFF', border: '1px solid #E6EDF3', borderRadius: 8, padding: 14, marginBottom: 18 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Focos (PT mais baixos primeiro):</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {resumo.map((r, i) => (
            <span key={i} style={{ background: '#eef3ff', border: '1px solid #dfe7ff', borderRadius: 999, padding: '6px 12px', fontSize: 13 }}>
              {NOMES_FATORES[r.fator] || r.fator} • PT {r.pt} ({r.faixa.replace('_', ' ')})
            </span>
          ))}
        </div>
      </div>

      {/* Semanas */}
      <div>
        {semanas.map((sem) => (
          <div key={sem.semana} style={{ border: '1px solid #eee', borderRadius: 8, padding: 16, marginBottom: 16 }}>
            <div style={{ fontWeight: 800, marginBottom: 10 }}>Semana {sem.semana}</div>
            {sem.tarefas.length === 0 && <div style={{ color: '#888' }}>— Sem tarefas nesta semana —</div>}
            {sem.tarefas.map((t, idx) => (
              <div key={idx} style={{ marginBottom: 12, paddingBottom: 12, borderBottom: '1px dashed #eee' }}>
                <div style={{ fontWeight: 700 }}>
                  {t.nomeFator} <span style={{ color: '#777', fontWeight: 400 }}>• {t.titulo}</span>
                </div>
                <div style={{ color: '#333' }}>{t.como}</div>
                <div style={{ color: '#667', fontSize: 13 }}>Rotina: {t.rotina}</div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
